import { connect } from 'react-redux';
import Global from '../../../../store/global-selectors';
import * as BatchPurchaseActions from '../../../../store/batches/purchase/batches.purchase.actions';
import { CostReviewBaseContainer } from '../../../../containers/cost-review-modal/cost-review-base-container';

import { CostReviewBody } from '../cost-review';

const mapStateToProps = (state, props) => {
  const { batchId: fulfillmentPlanSetId, error } = props;
  const { appliedSavings, costReviewSummary, isApplyingRecommendations, recommendationSummary, isLoadingCostReview } =
    Global.selectBatchesPurchaseFulfillmentPlanSetIdDerivedData(state, {
      fulfillmentPlanSetId,
    }) || {};

  const isCostReviewDataEmpty = !costReviewSummary || Object.entries(costReviewSummary).length === 0;
  const shouldShowError = error && isCostReviewDataEmpty;
  const isLoading = isLoadingCostReview || (isCostReviewDataEmpty && !error);

  const {
    userDateFormat,
    providers,
    walletedProviderGroups,
    insurances,
    balanceMaintained,
    enoughFunds,
    isContinueDisabled,
    userHasBillingInfoSetup,
    costWarnings,
    shipDate,
    shipFromCount,
  } = CostReviewBaseContainer(costReviewSummary, state);

  const { upsTermsRequired } = costReviewSummary ?? {};

  return {
    shipDate: Global.selectBatchesPurchaseShipDate(state) || shipDate,
    userDateFormat,
    providers,
    walletedProviderGroups,
    insurances,
    balanceMaintained,
    enoughFunds,
    isContinueDisabled,
    userHasBillingInfoSetup,
    costWarnings,
    shipFromCount,
    shouldShowError,
    isLoading,
    recommendationSummary,
    totalAppliedSavings: appliedSavings,
    isApplyingRecommendations,
    upsTermsRequired,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { batchId: fulfillmentPlanSetId } = props;
  return {
    walletPurchaseAmountChanged: (walletId, amount) =>
      dispatch(BatchPurchaseActions.walletPurchaseAmountChanged(fulfillmentPlanSetId, walletId, amount)),
    providerPurchaseAmountChanged: (provider, amount) =>
      dispatch(BatchPurchaseActions.providerPurchaseAmountChanged(fulfillmentPlanSetId, provider, amount)),
    insurancePurchaseAmountChanged: (provider, amount) =>
      dispatch(BatchPurchaseActions.insurancePurchaseAmountChanged(fulfillmentPlanSetId, provider, amount)),
    onShipDateChanged: (shipDate) => dispatch(BatchPurchaseActions.batchesPurchaseSetShipDate(shipDate)),
    onRetry: () => dispatch(BatchPurchaseActions.costReviewBatchesRetry(fulfillmentPlanSetId)),
    applyRecommendations: (bulkUpdateJobGuid, serviceFilters, insuranceFilters, rateShopperFilters, isRateShopperRecommendationsEnabled) =>
      dispatch(
        BatchPurchaseActions.batchCostReviewApplyRecommendations({
          fulfillmentPlanSetId,
          bulkUpdateJobGuid,
          serviceFilters,
          insuranceFilters,
          rateShopperFilters,
          isRateShopperRecommendationsEnabled,
        }),
      ),
  };
};

export const LabelBatchCostReview = connect(mapStateToProps, mapDispatchToProps)(CostReviewBody);
